export default Object.freeze({
  Add: 'add',
  Edit: 'edit',
  Delete: 'delete',
  Import: 'import',
  Export: 'export',
  Clear: 'clear',
});
